import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {EventsService} from '../../../../services/events/events.service';

@Component({
  selector: 'modal-message',
  styleUrls: [('./modalMessage.scss')],
  templateUrl: './modalMessage.html'
})

export class ModalMessage {
    header: string = '';
    message: string = '';

  constructor(
    private _activeModal: NgbActiveModal, 
    private _eventsService: EventsService
  ) {

  }

  ngOnInit() {}

  closeModal() {
    this._activeModal.close();
  }

}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalMessage/modalMessage.component.ts